import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import backArrow from '../../assets/back-arrow.svg';
import blobTop from '../../assets/blob-top.svg';
import blobBottom from '../../assets/blob-bottom.svg';

import './Layout.scss';

const Layout = (props) => {
  return (
    <div className={classnames('layout', { child: props.isChild, 'back-button': props.onBack })}>
      <img src={blobTop} alt="blob" className="layout__blob-top" />
      <img src={blobBottom} alt="blob" className="layout__blob-bottom" />
      <div className="main-container">
        {props.onBack && (
          <div onClick={props.onBack} className="back-to-sign-in">
            <img src={backArrow} alt="Back to sign in" />
            <div className="back-to-sign-in__icon" />
            Sign in instead
          </div>
        )}
        <main className="main">{props.children}</main>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  onBack: PropTypes.func,
  isChild: PropTypes.bool,
};

export default Layout;
